import classnames from "classnames"
import { useUIThemeContext } from "../ui/PathwrightUI"
import "./ProgressCircle.css"
import {
  ProgressCircle as ProgressCircleChakra,
  AbsoluteCenter
} from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"

const ProgressCircle = (props) => {
  let {
    strokeWidth = 3,
    colorPalette,
    trailWidth,
    className,
    children,
    progress = 0,
    icon,
    size
  } = props

  colorPalette ||= "gray"
  const color = `${colorPalette}.600`

  let kiddos = children
  if (icon) {
    kiddos = (
      <Pathicon
        icon={icon}
        style={{
          fontSize: "1.8em",
          color
        }}
      />
    )
  }

  return (
    <div className={classnames("ProgressCircle", className)}>
      <ProgressCircleChakra.Root
        // size={size}
        value={progress * 100 || 0}
        colorPalette={colorPalette}
        className="ProgressCircle__progress"
      >
        <ProgressCircleChakra.Circle
          css={{ "--thickness": `${strokeWidth}px`, "--size": `${size}px` }}
        >
          <ProgressCircleChakra.Track />
          <ProgressCircleChakra.Range />
        </ProgressCircleChakra.Circle>
        {kiddos && (
          <AbsoluteCenter>
            <ProgressCircleChakra.ValueText>
              {kiddos}
            </ProgressCircleChakra.ValueText>
          </AbsoluteCenter>
        )}
      </ProgressCircleChakra.Root>
    </div>
  )
}

ProgressCircle.displayName = "ProgressCircle"

export default ProgressCircle
